export const HOST_API = process.env.REACT_APP_API_BASE_URL ? process.env.REACT_APP_API_BASE_URL : 'https://staging-leaffilter.mhalt.com';
export const SCAN_API_URL = process.env.REACT_APP_SCAN_API_URL || 'https://scanapi.mhalt.com';

export const API_URL = 'https://staging-leaffilter.mhalt.com';

// AWS API Gateway URL for export functionality
export const AWS_API_GATEWAY_URL = process.env.REACT_APP_AWS_API_GATEWAY_URL || 'https://api-dev.mhalt.com';
